export default __webpack_public_path__ + "static/media/My-picture.380cf821.jpg";